import React from 'react';
import {
  Type,
  Shapes,
  Upload,
  Image as ImageIcon,
  Video,
  Sticker,
  Eraser,
  RotateCw,
  RotateCcw,
  ArrowUp,
  ArrowDown,
  Trash2,
  Save,
  Download,
} from 'lucide-react';

export default function EditorToolbar({
  onAddText,
  onAddShape,
  onUploadClick,
  onOpenImagePicker,
  onOpenVideoPicker,
  onOpenIconPicker,
  onRemoveBackground,
  onRotateLeft,
  onRotateRight,
  onBringForward,
  onSendBackward,
  onDelete,
  onSave,
  onExport,
}) {
  return (
    <aside className="manual-toolbar" aria-label="Ferramentas">
      <button type="button" className="manual-toolbar__btn" onClick={onAddText} title="Adicionar texto">
        <Type size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={() => onAddShape('rect')} title="Adicionar forma">
        <Shapes size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={onUploadClick} title="Upload local">
        <Upload size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={onOpenImagePicker} title="Buscar imagens Pexels">
        <ImageIcon size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={onOpenVideoPicker} title="Buscar vídeos Pexels">
        <Video size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={onOpenIconPicker} title="Buscar ícones Freepik">
        <Sticker size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={onRemoveBackground} title="Remover fundo">
        <Eraser size={18} />
      </button>

      <div className="manual-toolbar__divider" />

      <button type="button" className="manual-toolbar__btn" onClick={onRotateLeft} title="Rotacionar -15°">
        <RotateCcw size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={onRotateRight} title="Rotacionar +15°">
        <RotateCw size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={onBringForward} title="Trazer para frente">
        <ArrowUp size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={onSendBackward} title="Enviar para trás">
        <ArrowDown size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn manual-toolbar__btn--danger" onClick={onDelete} title="Excluir camada selecionada">
        <Trash2 size={18} />
      </button>

      <div className="manual-toolbar__divider" />

      <button type="button" className="manual-toolbar__btn" onClick={onSave} title="Salvar na biblioteca">
        <Save size={18} />
      </button>
      <button type="button" className="manual-toolbar__btn" onClick={onExport} title="Exportar PNG">
        <Download size={18} />
      </button>
    </aside>
  );
}
